import * as React from 'react'

function SvgCateDrama(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M2.83 17.084h18.34V7.326H2.83v9.758zm0 4.084h18.34v-3.253H2.83v3.253zM22 7.418a.925.925 0 00-.923-.924h-7.58l3.46-2.851L16.43 3l-4.24 3.494h-.377l-.026-.021L7.57 3l-.527.643 3.461 2.85H2.923A.925.925 0 002 7.42v13.656c0 .51.414.925.923.925h18.154a.925.925 0 00.923-.925V7.42z"
      />
    </svg>
  )
}

export default SvgCateDrama
